import React from 'react';
import MediaCommentList from './MediaCommentList';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';

const MediaModalWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: space-between;

  ${(props) => props.theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

const MediaBackground = styled.div`
  background-color: transparent;
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  position: relative;

  video {
    object-fit: cover;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    padding: 3rem 0;
  }
`;

const MediaWrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseModalButton = styled(CloseIcon)`
  top: 0.5rem;
  right: 0.5rem;
  font-size: 2rem;
  position: absolute;
  color: white;

  &:hover {
    background-color: ${(props) => props.theme.colors.neutral700};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    font-size: 2.5rem;
  }
`;

export interface MediaModalInterface {
  url?: string;
  caption?: string;
  comments?: MediaCommentsInterface[];
  id?: number;
  fileType?: string;
  onClose?: () => void;
}

export interface MediaCommentsInterface {
  id?: number;
  body?: string;
  user?: {
    id: number;
    firstName: string;
    lastName: string;
  };
  createdAt?: Date;
}

const MediaModal = ({ url, caption, comments, id, fileType, onClose }: MediaModalInterface) => {
  const type = fileType?.substring(0, fileType.indexOf('/'));

  return (
    <MediaModalWrapper>
      <MediaBackground onClick={onClose}>
        <CloseModalButton onClick={onClose} />
        <MediaWrapper onClick={(e) => e.stopPropagation()}>
          {type === 'video' ? (
            <video width='90%' height='auto' style={{ maxHeight: '95vh' }} controls>
              <source src={url} type='video/mp4' />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img
              style={{ width: 'calc(100% - 6rem)', height: 'auto', maxHeight: '95vh' }}
              src={url}
              alt={caption}
            />
          )}
        </MediaWrapper>
      </MediaBackground>
      <MediaCommentList comments={comments} id={id} />
    </MediaModalWrapper>
  );
};

export default MediaModal;
